import { IconPropsType } from '..';

export const WarningFilledIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.6001 19.5998H15.4001V22.3998H12.6001V19.5998ZM12.6 5.5998H15.4001L15.4 18.1998H12.6V5.5998ZM23.218 7.63819C22.1226 6.05099 20.6359 4.77352 18.9019 3.92948C17.168 3.08544 15.2454 2.70343 13.3205 2.82044C11.3955 2.93746 9.53341 3.54953 7.91444 4.59739C6.29547 5.64526 4.97449 7.0934 4.07943 8.8016C3.18437 10.5098 2.74555 12.4202 2.80546 14.3477C2.86537 16.2753 3.42198 18.1547 4.4214 19.8041C5.42082 21.4534 6.82917 22.8167 8.5101 23.762C10.191 24.7073 12.0875 25.2025 14.016 25.1998C16.057 25.1965 18.0582 24.6355 19.8035 23.5776C21.5488 22.5196 22.9719 21.0049 23.919 19.197C24.866 17.3891 25.3011 15.3568 25.1771 13.3197C25.0532 11.2825 24.375 9.31793 23.2157 7.63819H23.218Z"
      fill="#9CA2C2"
    />
  </svg>
);
